import { render, staticRenderFns } from "./LeasingPrescoreSelectQuestion.vue?vue&type=template&id=aca8fa1e&scoped=true&"
import script from "./LeasingPrescoreSelectQuestion.vue?vue&type=script&lang=js&"
export * from "./LeasingPrescoreSelectQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca8fa1e",
  null
  
)

export default component.exports